import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[viewMode]',
  standalone: true,
})
export class ViewModeDirective {
  public tpl = inject<TemplateRef<any>>(TemplateRef<any>);
}
